import { ComponentRenderHooks, ListItemsHooks } from "@launchos/plugins/types";
import LiveSocial from "./component";

export const onComponentRender = (hook, payload, actions) => {
  if (hook.id === ComponentRenderHooks.WEBCOMPONENT && payload.type === "Social") {
    return [LiveSocial];
  }
};
